export const hotelArrangementPlanFee: any = {
  feeType: {
    mandatoryFee: "フィー",
    mandatoryTax: "税",
    resortFee: "リゾートフィー",
  },
};
